<template>
  <div class="flex justify-end flex-col scale-75 border rounded shadow">
    <Button
      icon="pi pi-chevron-up"
      :class="[
        'btn-light scale-80 h-8',
        index === 0 ? '!bg-gray-200 cursor-default' : '',
      ]"
      :disabled="index === 0"
      @click.prevent="$emit('onOrder', 'up')"
    />
    <Button
      icon="pi pi-chevron-down"
      :class="[
        'btn-light scale-80 h-8',
        data === allData?.slice(-1)[0] ? '!bg-gray-200 cursor-default' : '',
      ]"
      :disabled="data === allData?.slice(-1)[0]"
      @click.prevent="$emit('onOrder', 'down')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["onOrder"],
  props: {
    index: Number,
    allData: Array,
    data: Object,
  },
});
</script>
